export const FORMS_UPDATE = 'FORMS_UPDATE';
export const FORMS_ERROR = 'FORMS_ERROR';
export const FORMS_ERROR_MULTIPLES = 'FORMS_ERROR_MULTIPLES';
export const FORMS_ERROR_SET_MULTIPLES = 'FORMS_ERROR_SET_MULTIPLES';
export const SIGN_UP_TRADER_STARTED = 'SIGN_UP_TRADER_STARTED';
export const SIGN_UP_TRADER_SUCCESS = 'SIGN_UP_TRADER_SUCCESS';
export const SIGN_UP_TRADER_ERROR = 'SIGN_UP_TRADER_ERROR';
export const SIGN_UP_FORM_SUBMITTED = 'SIGN_UP_FORM_SUBMITTED';
export const RESEND_ONBOARDING_MAIL_STARTED = 'RESEND_ONBOARDING_MAIL_STARTED';
export const RESEND_ONBOARDING_MAIL_SUCCESS = 'RESEND_ONBOARDING_MAIL_SUCCESS';
export const RESEND_ONBOARDING_MAIL_ERROR = 'RESEND_ONBOARDING_MAIL_ERROR';
